import {
  DealDataMappedType,
  DealDataResponseType
} from '@/components/ScrollableDealModule/types'
import analytics from '@/shared-utils/analytics'

const PACKAGE_DISPLAY_MINIMUM = 3

function setDealContent(deals: DealDataResponseType[]): DealDataMappedType[] {
  if (!Array.isArray(deals) || deals.length < PACKAGE_DISPLAY_MINIMUM) {
    analytics.logWarning({ message: 'Not enough packages to display deals' })
    return []
  }

  return deals.map(deal => {
    return {
      ...deal,
      id: `PACKAGE_DEAL_${deal.cityName.slice(-2)}`,
      image: deal.cityImageUrl,
      imageHeight: '284px',
      gaCategory: 'PACKAGES_LANDING',
      gaAction: 'Cached Deal',
      strikePrice:
        deal.priceAmount < deal.retailPriceAmount ? deal.retailPriceAmount : 0,
      gaLabel: deal.cityName,
      navArray: [
        {
          href: deal.searchLink,
          target: '_blank'
        }
      ]
    }
  })
}

export default setDealContent
